import { render, staticRenderFns } from "./SmartInsights.vue?vue&type=template&id=3fe51b68&scoped=true"
import script from "./SmartInsights.vue?vue&type=script&lang=js"
export * from "./SmartInsights.vue?vue&type=script&lang=js"
import style0 from "./SmartInsights.vue?vue&type=style&index=0&id=3fe51b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe51b68",
  null
  
)

export default component.exports